<template>
  <div class="nav">
    <a-card>
      <div class="header-page" @click="$router.push('/mypage')">
        <a>マイページトップ</a>
        <i class="icon icon-bor-arrow-right"></i>
      </div>
      <div v-for="(nav, index) in dataNavbars" :key="`nav-group-${index}`" class="nav-bar">
        <div class="title">{{nav.title}}</div>
        <div v-for="(nav, index1) in nav.navbar" :key="`nav-item-${index1}`" class="nav-item">
          <a-divider v-if="nav.type === 'divider'"/>
          <a v-else @click="handleClick(nav)" >{{nav.item}}</a>
          <span :class="'icon ' + nav.icon"></span>
        </div>
      </div>
      <div class="log-out" @click="showModalLogout() ">
        ログアウト 
      </div> 
       <div>
        <a-modal ok-text="ログアウト" 
          cancel-text="キャンセル"
          :visible="visiblePopupLogout"
          @ok="handleOkLogout"
          @cancel="handleCancelLogout">
          <p>ログアウトしてよろしいでしょうか？</p>
        </a-modal>
      </div> 
    </a-card>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'LeftMenuBarMock',
  data() {
    return {
      visiblePopupLogout: false,
      dataNavbars: [
        { 
          title: 'ベネポ',
          navbar: [ 
            {item: '総保有ベネポ・ベネポ履歴', path: '/mypage/benepo-history', icon: 'icon icon-bor-arrow-right'},
            {type: 'divider' },
            {item: '獲得予定のベネポ', path: '/mypage/benepo-collect', icon: 'icon icon-bor-arrow-right'}
          ]
        },
        {
          title: '補助クーポン',
          navbar: [{item: '補助クーポン', path: '/mypage/coupons', icon: 'icon icon-bor-arrow-right'}]
        },
        {
          title: '所属団体様専用ポイント・補助クーポン',
          navbar: [{item: '専用ポイント・補助クーポン', path: '/mypage/coupons', icon: 'icon icon-bor-arrow-right'}]
        },
        { 
          title: 'クーポン',
          navbar: [
            {item: 'マイクーポン', path: '/bs-myp-02-001', icon: 'icon icon-bor-arrow-right'},
            {type: 'divider' },
            {item: '過去のクーポン', path: '/bs-myp-02-010', icon: 'icon icon-bor-arrow-right'}
          ]
        },
        {
          title: 'お申し込み履歴',
          navbar: [
            { item: 'お申し込み', path: '/mypage/orders', icon: 'icon icon-bor-arrow-right' },
            { type: 'divider' },
            { item: '投稿したクチコミ', href: '/', icon: 'icon icon-bor-arrow-right' },
            { type: 'divider' },
            { item: '給与天引きご利用履歴', href: '/', icon: 'icon icon-bor-full-screen' }
          ]
        },
        {
          title: '閲覧履歴',
          navbar: [{ item: '閲覧履歴', path: '/mypage/visits', icon: 'icon icon-bor-arrow-right' }]
        },
        {
          title: 'お気に入り',
          navbar: [
            { item: 'お気に入りメニュー', path: '/mypage/favorites', icon: 'icon icon-bor-arrow-right' },
            { type: 'divider' },
            { item: 'Wishリスト', href: '', icon: 'icon icon-bor-arrow-right' }
          ]
        },
        {
          title: '会員設定',
          navbar: [
            { item: '会員プロフィール', path: '/mypage/setting', icon: 'icon icon-bor-arrow-right' },
            { type: 'divider' },
            { item: '　-  メール受信・通知', href: '', icon: 'icon icon-bor-arrow-right' },
            { type: 'divider' },
            { item: '　-  クレジットカード', href: '', icon: 'icon icon-bor-full-screen' }
          ]
        },
        { 
          title: '家族設定',
          navbar: [ 
            {item: '家族アカウント管理', href: '', _blank: true, icon: 'icon icon-bor-full-screen'},
            { type: 'divider' }
          ]
        }
      ]
    }
  },
  computed: {
    getAuthenState() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    }
  },
  mounted() {
   
  },
  methods: {
    showModalLogout() {
      this.visiblePopupLogout = true
    },
    nextPage(path) {
      this.$router.push(path)
    },
    handleClick(navItem) {
      if (navItem.href) {
        if (navItem._blank) {
          window.open(navItem.href)
        } else {
          location.href = navItem.href
        }
        return
      }
      if (navItem.path) {
        this.$router.push(navItem.path)
      }
    },
    handleOkLogout() {
      this.logout()
    },
    handleCancelLogout() {
      this.visiblePopupLogout = false
    },
    async logout() {
      // CRM独自対応
      // window.dataLayer.push({
      //   event: "braze_logout",
      // });
      const boCode = this.$store.getters["params/get"].boCode
      this.$repositories('user').logout(boCode).then(() => {
        this.$auth.user = null
        this.$auth.loggedIn = false
      })
    }
  }
}
</script>

<style lang="scss">
  @import './style.scss';
  .ant-divider{
    margin: 6px 0 !important;
  }
</style>